/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { PaginatedProjectListList, PatchedProject, Project } from "../models/index";
import {
  PaginatedProjectListListFromJSON,
  PaginatedProjectListListToJSON,
  PatchedProjectFromJSON,
  PatchedProjectToJSON,
  ProjectFromJSON,
  ProjectToJSON,
} from "../models/index";

export interface ProjectsCreateRequest {
  project: Omit<Project, "url" | "created_at" | "updated_at" | "organisation_name" | "themes">;
}

export interface ProjectsDestroyRequest {
  slug: string;
}

export interface ProjectsListRequest {
  page?: number;
}

export interface ProjectsPartialUpdateRequest {
  slug: string;
  patchedProject?: Omit<
    PatchedProject,
    "url" | "created_at" | "updated_at" | "organisation_name" | "themes"
  >;
}

export interface ProjectsRetrieveRequest {
  slug: string;
}

export interface ProjectsUpdateRequest {
  slug: string;
  project: Omit<Project, "url" | "created_at" | "updated_at" | "organisation_name" | "themes">;
}

/**
 *
 */
export class ProjectsApi extends runtime.BaseAPI {
  /**
   */
  async projectsCreateRaw(
    requestParameters: ProjectsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Project>> {
    if (requestParameters["project"] == null) {
      throw new runtime.RequiredError(
        "project",
        'Required parameter "project" was null or undefined when calling projectsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/projects/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ProjectToJSON(requestParameters["project"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
  }

  /**
   */
  async projectsCreate(
    requestParameters: ProjectsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Project> {
    const response = await this.projectsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async projectsDestroyRaw(
    requestParameters: ProjectsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling projectsDestroy().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/projects/{slug}/`;
    urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters["slug"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async projectsDestroy(
    requestParameters: ProjectsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async projectsListRaw(
    requestParameters: ProjectsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedProjectListList>> {
    const queryParameters: any = {};

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/projects/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedProjectListListFromJSON(jsonValue)
    );
  }

  /**
   */
  async projectsList(
    requestParameters: ProjectsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedProjectListList> {
    const response = await this.projectsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async projectsPartialUpdateRaw(
    requestParameters: ProjectsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Project>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling projectsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/projects/{slug}/`;
    urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters["slug"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchedProjectToJSON(requestParameters["patchedProject"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
  }

  /**
   */
  async projectsPartialUpdate(
    requestParameters: ProjectsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Project> {
    const response = await this.projectsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async projectsRetrieveRaw(
    requestParameters: ProjectsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Project>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling projectsRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/projects/{slug}/`;
    urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters["slug"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
  }

  /**
   */
  async projectsRetrieve(
    requestParameters: ProjectsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Project> {
    const response = await this.projectsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async projectsUpdateRaw(
    requestParameters: ProjectsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Project>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling projectsUpdate().'
      );
    }

    if (requestParameters["project"] == null) {
      throw new runtime.RequiredError(
        "project",
        'Required parameter "project" was null or undefined when calling projectsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/projects/{slug}/`;
    urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters["slug"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ProjectToJSON(requestParameters["project"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectFromJSON(jsonValue));
  }

  /**
   */
  async projectsUpdate(
    requestParameters: ProjectsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Project> {
    const response = await this.projectsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
